module.exports = __webpack_public_path__ + "img/traffic-lights.5ba0a371.png";